exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contacts[data-v-072b2823]{display:flex;flex-direction:column;align-items:center;padding-bottom:40px}.contacts a[data-v-072b2823]{color:#fff}.map[data-v-072b2823]{height:520px}", ""]);

// exports
